import appraisalHeaderImg from '../../assets/img/appraisal-bg-new.png';
import logo from '../../assets/img/saw-logo.png';

export const ErrorPage = (props: any) => {
  return <div className='container error-page '>
    <div className='row text-left ml-1 mt-1'>
      <img alt="logo-png" src={logo} className="header-logo" />
    </div>
    <br />
    <div className='error-body'>
      <img alt="" className="error-bg-image" src={appraisalHeaderImg}></img>
      <BlockedCountries />
    </div>
    <footer className='error-footer'>
      <label>We also invite you to stay in touch via the following social media channels </label>
      <div className="d-flex social-media-icon">
        <i onClick={() => window.open('https://www.facebook.com/sawcom/')} className="fab fa-facebook-f   "></i>
        <i onClick={() => window.open('https://www.linkedin.com/company/saw-com/')} className="fab fa-linkedin" aria-hidden="true"></i>
        <i onClick={() => window.open('https://twitter.com/sawsells')} className="fab fa-twitter"></i>
        <i onClick={() => window.open('https://www.youtube.com/channel/UCPmoATtesikiA5XCIBu4URw')} className="fab fa-youtube"></i>
      </div>
    </footer>
  </div>
}

export const BlockedCountries = () => {
  return <div className='blocked-country-error'>
    <p>
      Thanks for visiting Saw.com - the brokerage firm that’s changing the domain game. Unfortunately, we don’t currently support your area with our service.
      Sorry! Please call or text <span className='f-bold theme-color'>+1-781-281-9475</span> with questions.
    </p>
  </div>
}
